const errors: Record<string, string> = {
  oauth_not_configured: "Google OAuth chưa được cấu hình đầy đủ.",
  oauth_failed: "Phiên đăng nhập không hợp lệ hoặc đã hết hạn.",
  token_exchange: "Google chưa thể xác nhận phiên đăng nhập.",
  missing_identity: "Không đọc được thông tin tài khoản Google.",
  unverified_email: "Tài khoản Google cần có email đã xác minh.",
};

export default function LoginPage() {
  const params = new URLSearchParams(window.location.search);
  const error = params.get("error");
  const returnTo = params.get("return_to");
  const startUrl = `/api/auth/google/start${returnTo?.startsWith("/") && !returnTo.startsWith("//") ? `?return_to=${encodeURIComponent(returnTo)}` : ""}`;

  return (
    <main className="login-shell">
      <section className="login-card" aria-labelledby="login-title">
        <a className="login-brand" href="/login"><span>CC</span><strong>Chuyên Chọn</strong></a>
        <h1 id="login-title">Đăng nhập Chuyên Chọn.</h1>
        {error && <div className="login-error" role="alert">{errors[error] ?? "Đăng nhập chưa thành công. Em thử lại nhé."}</div>}
        <a className="google-login-button" href={startUrl}>
          <span aria-hidden="true">G</span>
          Tiếp tục với Google
        </a>
      </section>
    </main>
  );
}
